import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from '@mui/material/Skeleton';

const DEFAULT_SKELETON_COUNT = 5;

const SearchHistorySkeleton = ({ count = DEFAULT_SKELETON_COUNT }) => {
  const skeletonCount = count > 0 ? count : DEFAULT_SKELETON_COUNT;

  return (
    <>
      {Array(skeletonCount)
        .fill()
        .map((_, index) => (
          <div key={index} className='history-item skeleton'>
            <Skeleton animation='wave' height={34} width={72} />
            <Skeleton animation='wave' height={36} width='85%' />
          </div>
        ))}
    </>
  );
};

SearchHistorySkeleton.propTypes = {
  count: PropTypes.number,
};

export default SearchHistorySkeleton;
